import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { SearchHistoryConstant } from "./SearchHistoryConstant";

const initialState = {
    SearchHistoryDataList: [],
    SearchHistoryDataloading: {
    isLoading: false,
  },


};

export const SearchHistoryDataReducer = persistReducer(
  {
    storage,
    key: "SearchHistoryData",
    whitelist: ["SearchHistoryDataList"],
  },

  (state = initialState, { type, payload }) => {
    switch (type) {
      case SearchHistoryConstant.SEARCHHISTORY_REQUEST: {
        return {
          ...state,
          SearchHistoryDataList: [],
          SearchHistoryDataloading: {
            isLoading: true,
          },
        };
      }

      case SearchHistoryConstant.SEARCHHISTORY_RESPONSE: {
        return {
          ...state,
          SearchHistoryDataList: payload,
          SearchHistoryDataloading: {
            isLoading: false,
          },
        };
      }

     

      default:
        return state;
    }
  }
);
